// Token cost table — internal units per AI operation.
//
// 1 token = INTERNAL_UNITS_PER_TOKEN units. UI shows tokens (rounded up);
// ledger + usage log store units for precision. Changing cost values here
// requires a deploy but needs no data migration — all historical ledger rows
// record whatever unit count was charged at their moment.

export const INTERNAL_UNITS_PER_TOKEN = 10;

export const COST = {
  embed: { perItem: 2 },     // per bookmark embedded
  chat: { perCall: 50 },     // per nameCluster LLM call (batched reps)
  titleInfer: { perItem: 5 },// per bookmark (Phase D)
  descriptionInfer: { perItem: 5 }, // per bookmark — TLDR 2-3 sentences (premium)
  classifyTieBreak: { perCall: 5 }, // per /suggest LLM tie-break (MF-80)
  // MF-123 — Ask MarkFlow RAG. One call = query embed (~2u) + ~12-bookmark
  // chat completion. 10u/call ≈ middle of typical token spend; revise after
  // first week of telemetry.
  chatRag: { perCall: 10 },
} as const;

export const GRANTS = {
  signupBonus: 500 * INTERNAL_UNITS_PER_TOKEN,
  grandfather: 500 * INTERNAL_UNITS_PER_TOKEN,
} as const;

export function tokensToUnits(tokens: number): number {
  return Math.round(tokens * INTERNAL_UNITS_PER_TOKEN);
}

export function unitsToTokens(units: number): number {
  return Math.ceil(units / INTERNAL_UNITS_PER_TOKEN);
}

// Snap a unit count UP to the next whole-token boundary. All ledger writes
// must go through this so token_transactions.delta_units stays a multiple of
// INTERNAL_UNITS_PER_TOKEN — otherwise sum(unitsToTokens per row) drifts from
// unitsToTokens(sum) by the rounding remainders.
export function snapToTokenBoundary(units: number): number {
  if (units <= 0) return 0;
  return Math.ceil(units / INTERNAL_UNITS_PER_TOKEN) * INTERNAL_UNITS_PER_TOKEN;
}
